module.exports = __webpack_public_path__ + "static/media/leetcode_streak.fb750f86.png";